import { render, staticRenderFns } from "./PopinError.vue?vue&type=template&id=a4568948"
import script from "./PopinError.vue?vue&type=script&lang=js"
export * from "./PopinError.vue?vue&type=script&lang=js"
import style0 from "./PopinError.vue?vue&type=style&index=0&id=a4568948&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports